import { Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import * as moment from 'moment';
import 'moment/locale/sv';
import 'moment/locale/en-gb';

@Injectable({
  providedIn: 'root'
})
export class DateLocaleService {
  private currentLocale = 'sv';

  constructor(private transloco: TranslocoService) {
    // Initialize with current language
    this.updateLocale();

    // Listen to language changes
    this.transloco.langChanges$.subscribe(() => {
      this.updateLocale();
    });
  }

  private updateLocale(): void {
    const currentLang = this.transloco.getActiveLang();
    this.currentLocale = currentLang;

    if (currentLang === 'sv') {
      moment.locale('sv');
    } else {
      moment.locale('en-gb');
    }
  }

  getCurrentLocale(): string {
    return this.currentLocale;
  }

  getFirstDayOfWeek(): number {
    return this.currentLocale === 'sv' ? 1 : 0;
  }
}